import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/colecoes',
)({
  component: function ColecoesLayout() {
    return <Outlet />
  },
})
